import * as API from 'common/constant/routes'
import { postJson } from 'helper/http'

export const addUrlChange = (location) => postJson(API.ADD_URL_CHANGE, {}, { ...location })
